"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _Icons = require("./Icons");
var _FeedbackContext = require("../feedback/FeedbackContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Clipboard(_ref) {
  var value = _ref.value,
    label = _ref.label,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outlined' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? 'dense' : _ref$margin,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'info' : _ref$color,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? true : _ref$readOnly,
    disabled = _ref.disabled;
  var feedbackContext = (0, _react.useContext)(_FeedbackContext.FeedbackContext);
  var inputRef = (0, _react.useRef)(null);
  var copyToClipboard = (0, _react.useCallback)(function () {
    if (!inputRef.current) {
      feedbackContext.showWarning((0, _core.translate)('clipboard.no_input'));
      return;
    }
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      var range = document.createRange();
      range.selectNodeContents(inputRef.current);
      var selection = window.getSelection();
      if (!selection) {
        feedbackContext.showWarning((0, _core.translate)('clipboard.no_selection'));
        return;
      }
      selection.removeAllRanges();
      selection.addRange(range);
      inputRef.current.setSelectionRange(0, 999999);
    } else {
      inputRef.current.select();
    }
    document.execCommand('copy');
    if (label) {
      feedbackContext.showSuccess((0, _core.translate)('clipboard.copied_label', {
        label: label
      }));
    } else {
      feedbackContext.showSuccess((0, _core.translate)('clipboard.copied'));
    }
  }, [feedbackContext, label]);
  return /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    variant: variant,
    margin: margin,
    size: size,
    defaultValue: value,
    label: label,
    disabled: disabled,
    inputRef: inputRef,
    InputProps: {
      endAdornment: (/*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        color: color,
        onClick: copyToClipboard
      }, /*#__PURE__*/_react["default"].createElement(_Icons.CopyIcon, null))),
      readOnly: readOnly
    },
    fullWidth: fullWidth
  });
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Clipboard);